module.exports = __webpack_public_path__ + "media/bootstrap-icons/shield-plus-b8180d1c.svg";